module.exports = __webpack_public_path__ + "img/sk.162bec20.svg";